'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposureNeg1 = function ImageExposureNeg1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
  );
};
ImageExposureNeg1 = (0, _pure2.default)(ImageExposureNeg1);
ImageExposureNeg1.displayName = 'ImageExposureNeg1';
ImageExposureNeg1.muiName = 'SvgIcon';

exports.default = ImageExposureNeg1;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/exposure-neg-1.js
// module id = 1533
// module chunks = 0